import { resolveIconUrl } from '../../utils/resolveIconUrl.util';

interface ResolvedIconProps {
  imageLink: string | null;
  alt: string;
  className?: string;
}

const ResolvedIcon = ({ imageLink, alt, className }: ResolvedIconProps) => {
  const url = resolveIconUrl(imageLink);
  if (!url) return null;

  return <img src={url} alt={alt} className={className} />;
};

export { ResolvedIcon };
